import Pin from './pin'
import Collection from "../../data-structures/collection"
import {PinData, PinLocationTypes} from "./@types"
import {SESSION_PINS_CHANGED} from "../../gd/bus/bus-event-type";
import {SpaceProto} from "../space/space-proto";
import Workspace from "../space/workspaces/workspace";
import ProjectSession from "../project/project-session";
import ProjectSessionCollection from "../project/collection";
import {EntityType} from "../../gd/const/item"

// const debug = "PinsCollection"
const debug = false

export default class PinsCollection extends Collection<Pin>{

    constructor(models:Pin[]) {
        super(models);
    }

    public resetFromJson(data: any): void {
        debug && console.log(debug, 'resetFromJson', data)

        const models: Pin[] = []

        _.map(data, (record: JSONObject)=>{

            const pin = new Pin(record)

            if (!pin.isValid) {
                debug && console.warn("PinsCollection: Broken pin. pin=", pin)
                return
            }

            models.push(pin)
        })

        this.reset(models)
    }

    static initFromJson(data: any): PinsCollection{

        const models: Pin[] = []

        _.map(data, (record: JSONObject)=>{

            const pin = new Pin(record)

            if (!pin.isValid) {
                console.error("#9382672563 Broken pin. pin=", pin)
                return
            }

            models.push(pin)
        })

        return new PinsCollection(models)
    }

    add(model: Pin | null) {
        super.add(model)

        gd.bus.triggerEvent(SESSION_PINS_CHANGED)
    }

    remove(id: ID): Pin[] {
        const removed = super.remove(id)

        gd.bus.triggerEvent(SESSION_PINS_CHANGED)

        return removed
    }

    reset(models?: Pin[]) {

        // const validModels = _.filter(models, (pin)=>{ return pin.isValid })

        super.reset(models)

        gd.bus.triggerEvent(SESSION_PINS_CHANGED)
    }

    getPinByData(pinData: PinData): Pin | null {
        const pinId = this.getPinId(pinData)
        return pinId ? this.get(pinId) : null
    }

    getPinId(data: PinData): ID | undefined {
        const { projectId, taskId, userId, organizationId, documentId, customViewId } = data
        let result

        if (taskId) {
            result = _.find(this.models, (pin: Pin) => pin.task?.id === taskId)?.id
        } else if (projectId) {
            result = _.find(this.models, (pin: Pin) => pin.project?.id === projectId)?.id
        } else if (customViewId) {
            result = _.find(this.models, (pin: Pin) => pin.customViewId === customViewId)?.id
        } else if (userId && organizationId) {
            result = _.find(this.models, (pin: Pin) => pin.user?.companyId === organizationId && pin.user?.userId === userId)?.id
        } else if (documentId) {
            result = _.find(this.models, (pin: Pin) => pin.document?.id === documentId)?.id
        }

        return result
    }

    // it is in use - search by name
    deletePinById(pinId: ID) {
        this.remove(pinId)
        gd.api.Pins.removePin(pinId)
    }

    getProjects():PinsCollection {
        const projectsPins: Pin[] = _.filter(this.models, (pin:Pin)=>{
            return !!gd.session.projects.get(pin.project?.id)
        })
        return new PinsCollection(projectsPins)
    }

    getSessionProjects(collection: ProjectSessionCollection):ProjectSession[] {

        let sessionProjects: ProjectSession[] = []

        _.map(this.models, (pin:Pin)=>{

            const project = collection.get(pin.project?.id)

            if(project && !project.isTag){
                sessionProjects.push(project)
            }
        })
        return sessionProjects
    }


    get projectPins():Pin[] {

        // @ts-ignore
        let pinnedItems : Pin[] = _.filter(this.models,(pin)=>{
            // filter projects only & make sure we have this project in session
            // to prevent error i.e. when delete project and session data still old
            if (!pin.project) return false;

            const sessionProject = gd.session.projects.get(pin.project.id);

            return sessionProject && sessionProject.companyId===gd.companyId;
        });

        return pinnedItems


    }

    spacePins(space:SpaceProto):Pin[] {

        let pins: Pin[] = []

        if (space.isWorkspace) {

            pins = _.filter(this.models, (pin: Pin)=>{

                // // just in case
                // if (pin.companyId !== gd.companyId) return false

                // if (pin.location.type === PinLocationTypes.WORKSPACE && pin.location.value === space.id) return false
                //
                // return !!pin.task || !!pin.document || !!pin.user

                const workspace = space as Workspace

                return pin.location.type === PinLocationTypes.WORKSPACE &&
                    pin.location.value === workspace.project.id &&
                    pin.type !== EntityType.CUSTOM_VIEW // custom views no longer can be pinned
            })

            return pins
        }

        if (!space.isWorkspace) {

            // I guess we support home only ... ?

            pins = _.filter(this.models, (pin: Pin)=>{

                // // just in case
                // if (pin.companyId !== gd.companyId) return false

                // if (pin.location.type === PinLocationTypes.WORKSPACE && pin.location.value === space.id) return false
                //
                // return !!pin.task || !!pin.document || !!pin.user

                return pin.location.type !== PinLocationTypes.WORKSPACE &&
                    pin.type !== EntityType.CUSTOM_VIEW // custom views no longer can be pinned
            })

            return pins
        }


        return pins

        // const pins: Pin[] = _.filter(this.models, (pin: Pin)=>{
        //
        //     // just in case
        //     if (pin.companyId !== gd.companyId) return false
        //
        //     if (pin.location.type !== pinLocation.type || pin.location.value !== pinLocation.value) return false
        //
        //     return !!pin.task || !!pin.document || !!pin.user
        // })
        //
        // if (!pinnedItems || pinnedItems.length < 1) return []
    }



}
